// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { bonesDeclaration } from "core/Shaders/ShadersInclude/bonesDeclaration";
import { bakedVertexAnimationDeclaration } from "core/Shaders/ShadersInclude/bakedVertexAnimationDeclaration";
import { instancesDeclaration } from "core/Shaders/ShadersInclude/instancesDeclaration";
import { clipPlaneVertexDeclaration } from "core/Shaders/ShadersInclude/clipPlaneVertexDeclaration";
import { logDepthDeclaration } from "core/Shaders/ShadersInclude/logDepthDeclaration";
import { fogVertexDeclaration } from "core/Shaders/ShadersInclude/fogVertexDeclaration";
import { instancesVertex } from "core/Shaders/ShadersInclude/instancesVertex";
import { bonesVertex } from "core/Shaders/ShadersInclude/bonesVertex";
import { bakedVertexAnimation } from "core/Shaders/ShadersInclude/bakedVertexAnimation";
import { clipPlaneVertex } from "core/Shaders/ShadersInclude/clipPlaneVertex";
import { logDepthVertex } from "core/Shaders/ShadersInclude/logDepthVertex";
import { fogVertex } from "core/Shaders/ShadersInclude/fogVertex";
import { vertexColorMixing } from "core/Shaders/ShadersInclude/vertexColorMixing";

const name = "fireVertexShader";
const shader = `precision highp float;attribute vec3 position;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
uniform mat4 view;uniform mat4 viewProjection;
#ifdef DIFFUSE
varying vec2 vDiffuseUV;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
varying vec3 vPositionW;
#ifdef VERTEXCOLOR
varying vec4 vColor;
#endif
#include<clipPlaneVertexDeclaration>
#include<logDepthDeclaration>
#include<fogVertexDeclaration>
uniform float time;uniform float speed;
#ifdef DIFFUSE
varying vec2 vDistortionCoords1;varying vec2 vDistortionCoords2;varying vec2 vDistortionCoords3;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#ifdef VERTEXCOLOR
vec4 colorUpdated=color;
#endif
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(position,1.0);gl_Position=viewProjection*worldPos;vPositionW=vec3(worldPos);
#ifdef DIFFUSE
vDiffuseUV=uv;vDiffuseUV.y-=0.2;
#endif
#include<clipPlaneVertex>
#include<logDepthVertex>
#include<fogVertex>
#include<vertexColorMixing>
#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
#ifdef DIFFUSE
vec3 layerSpeed=vec3(-0.2,-0.52,-0.1)*speed;vDistortionCoords1.x=uv.x;vDistortionCoords1.y=uv.y+layerSpeed.x*time/1000.0;vDistortionCoords2.x=uv.x;vDistortionCoords2.y=uv.y+layerSpeed.y*time/1000.0;vDistortionCoords3.x=uv.x;vDistortionCoords3.y=uv.y+layerSpeed.z*time/1000.0;
#endif
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
const includes = [bonesDeclaration, bakedVertexAnimationDeclaration, instancesDeclaration, clipPlaneVertexDeclaration, logDepthDeclaration, fogVertexDeclaration, instancesVertex, bonesVertex, bakedVertexAnimation, clipPlaneVertex, logDepthVertex, fogVertex, vertexColorMixing];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStore[inc.name]) {
        ShaderStore.IncludesShadersStore[inc.name] = inc.shader;
    }
}

/** @internal */
export const fireVertexShader = { name, shader };
